import React from 'react'
import {Box, SimpleGrid, Heading, Button} from '@chakra-ui/react'
import Link from '@salesforce/retail-react-app/app/components/link'
import {pxToRem} from '../../utills/pxToRem'
import {fonts} from '../../theme/foundations/fonts'
import {FormattedMessage} from 'react-intl'
import PropTypes from 'prop-types'
function RelatedArticles({relatedArticlesData, onLoadMore, showLoadMore, articlesCount}) {
    return (
        <Box color="black" fontFamily={fonts.primary}>
            <Heading
                id="search-related-articles"
                as={'h2'}
                fontSize={[pxToRem(18), pxToRem(18), pxToRem(22), pxToRem(22)]}
                fontStyle="normal"
                fontWeight={600}
                lineHeight="normal"
                letterSpacing={pxToRem(3)}
                textTransform="uppercase"
                marginBottom={5}
                fontFamily={fonts.primary}
            >
                <FormattedMessage
                    id="product_list.related_articles.title"
                    defaultMessage="Related Articles Found ({articlesCount})"
                    values={{articlesCount}}
                />
            </Heading>
            <SimpleGrid
                columns={{base: 1, md: 3}}
                spacing={[pxToRem(10), pxToRem(10), pxToRem(25), pxToRem(25)]}
            >
                {relatedArticlesData?.map((article) => (
                    <Link
                        to={`/content/${article.id}.html`}
                        key={article.id}
                        overflow="hidden"
                        display="flex"
                        flexDirection="column"
                        justifyContent="center"
                        backgroundColor="cav_deep_light_gray"
                        px={[pxToRem(10), pxToRem(10), pxToRem(15), pxToRem(15)]}
                        py={[pxToRem(15), pxToRem(15), pxToRem(20), pxToRem(20)]}
                        _hover={{
                            textDecoration: 'none'
                        }}
                    >
                        <Box
                            noOfLines={2}
                            fontSize={[pxToRem(14), pxToRem(14), pxToRem(16), pxToRem(16)]}
                            fontStyle="normal"
                            fontWeight={500}
                            lineHeight="normal"
                            letterSpacing={pxToRem(1)}
                            textTransform="uppercase"
                            height="100%"
                        >
                            {article.name}
                        </Box>
                        <Link
                            to={`/content/${article.id}.html`}
                            fontSize={[pxToRem(12), pxToRem(12), pxToRem(14), pxToRem(14)]}
                            fontStyle="normal"
                            fontWeight={500}
                            lineHeight="normal"
                            letterSpacing={[pxToRem(1), pxToRem(1), pxToRem(2.1), pxToRem(2.1)]}
                            textTransform="uppercase"
                            mt={[pxToRem(15), pxToRem(15), pxToRem(20), pxToRem(20)]}
                            _hover={{
                                color: 'cav_calltoaction_darkred',
                                textDecoration: 'underline'
                            }}
                        >
                            <FormattedMessage
                                id="product_list.related_articles.readMore"
                                defaultMessage="Read More >>"
                            />
                        </Link>
                    </Link>
                ))}
            </SimpleGrid>
            {showLoadMore && (
                <Box mt={[pxToRem(30), pxToRem(30), pxToRem(40), pxToRem(40)]} textAlign="center">
                    <Button variant="red" size="base" onClick={onLoadMore}>
                        <FormattedMessage
                            defaultMessage="Load more >>"
                            id="product_list.btn.loadmore.label"
                        />
                    </Button>
                </Box>
            )}
        </Box>
    )
}

RelatedArticles.propTypes = {
    relatedArticlesData: PropTypes.array.isRequired,
    onLoadMore: PropTypes.func.isRequired,
    showLoadMore: PropTypes.bool.isRequired,
    articlesCount: PropTypes.number.isRequired
}

export default RelatedArticles
